import axios from "axios";
import * as types from "./types";

export default {
  async [types.GET_CERTIFICATE_TYPES]({ commit }, payload = {}) {
    const params = payload.all ? "?all=true" : "";  
    return axios
      .get(`/api/consultant_certificates/certificate_types${params}`)
      .then((resp) => {
        commit(types.MUTATE_CERTIFICATE_TYPES, resp.data);
        return resp;
      });
  },

  async [types.SEARCH_CERTIFICATES]({ commit }, payload) {
    return axios
      .post(`/api/consultant_certificates/search?page=${payload.page}`, payload)
      .then((resp) => {
        commit(types.MUTATE_CERTIFICATES_SEARCH_RESULT, resp.data);
        return resp;
      });
  },
  
  [types.OPEN_NEW_CERTIFICATE_TYPE_SIDEBAR]({ commit }, payload = {}) {
  commit(types.MUTATE_NEW_CERTIFICATE_TYPE_SIDEBAR, {
    visible: true,
    ...payload,
  });
  },

  [types.SAVE_CERTIFICATE_TYPE]: ({}, payload) => {
    return axios
      .put(`/api/consultant_certificates/`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  [types.OPEN_MANAGE_CERTIFICATE_TYPES_SIDEBAR]({ commit }, payload) {
    commit(types.MUTATE_MANAGE_CERTIFICATE_TYPES_SIDEBAR, {
      visible: true,
      ...payload,
    });
  },
  
  [types.UPDATE_CERTIFICATE_TYPE]: ({}, payload) => {
    return axios
      .post(`/api/consultant_certificates/type/${payload.id}`, payload)
      .then((resp) => Promise.resolve(resp))
      .catch((err) => Promise.reject(err));
  },
};